import urlBuilder from "./urlBuilder";
import { PAGE_TYPE } from "../pages/page.types";
import getUmbracoEndPoint from "./UmbracoEndPoint";

export default async <T = PAGE_TYPE> (doctype: string, route: string): Promise<T> => {
    const url = urlBuilder("/api/content/type", { contentType: doctype, url: route });

    const response = await fetch(url.toString(), {
        method: "GET",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json",
            "Origin": getUmbracoEndPoint(),
            "X-Request-Domain": getUmbracoEndPoint()
        },
        body: undefined
    });

    if (response.status === 200) {
        return await response.json();
    }
    else {
        return new Promise<any>((resolve) => {
            return resolve({
                status: response.status
            });
        });
    }
};